<template>
    <div
        v-show="showingContextMenu"
        ref="contextMenu"
        v-on-click-outside="hideContextMenu"
        class="absolute z-50 bg-white rounded-md shadow-md min-w-[260px] dark:bg-neutral-950"
    >
        <ul class="divide-y divide-stone-300 dark:divide-neutral-800">
            <li class="py-2">
                <ul>
                    <li>
                        <button
                            type="button"
                            class="flex items-center w-full px-2 space-x-2 bg-white hover:bg-stone-100 dark:bg-neutral-950 dark:hover:bg-neutral-900"
                            @click="contextCommand(() => editor.chain().focus().undo().run())"
                        >
                            <span class="relative grow-0 px-2">
                                <icon icon="fa/solid/rotate-left" class="w-3 h-3"></icon>
                            </span>
                            <span class="flex-auto py-1.5 text-sm text-left">
                                {{ lang('common::common.wysiwyg.undo') }}
                            </span>
                        </button>
                    </li>
                    <li>
                        <button
                            type="button"
                            class="flex items-center w-full px-2 space-x-2 bg-white hover:bg-stone-100 dark:bg-neutral-950 dark:hover:bg-neutral-900"
                            @click="contextCommand(() => editor.chain().focus().redo().run())"
                        >
                            <span class="relative grow-0 px-2">
                                <icon icon="fa/solid/rotate-right" class="w-3 h-3"></icon>
                            </span>
                            <span class="flex-auto py-1.5 text-sm text-left">
                                {{ lang('common::common.wysiwyg.redo') }}
                            </span>
                        </button>
                    </li>
                </ul>
            </li>
            <li class="py-2">
                <ul>
                    <li>
                        <button
                            type="button"
                            class="flex items-center w-full px-2 space-x-2 bg-white hover:bg-stone-100 dark:bg-neutral-950 dark:hover:bg-neutral-900"
                            @click="contextCommand(() => emit('insert-image'))"
                        >
                            <span class="relative grow-0 px-2">
                                <icon icon="fa/solid/image" class="w-3 h-3"></icon>
                            </span>
                            <span class="flex-auto py-1.5 text-sm text-left">
                                {{ lang('common::common.wysiwyg.insert_image') }}
                            </span>
                        </button>
                    </li>
                    <li>
                        <button
                            type="button"
                            class="flex items-center w-full px-2 space-x-2 bg-white hover:bg-stone-100 dark:bg-neutral-950 dark:hover:bg-neutral-900"
                            @click="contextCommand(() => emit('insert-file'))"
                        >
                            <span class="relative grow-0 px-2">
                                <icon icon="fa/solid/file" class="w-3 h-3"></icon>
                            </span>
                            <span class="flex-auto py-1.5 text-sm text-left">
                                {{ lang('common::common.wysiwyg.insert_file') }}
                            </span>
                        </button>
                    </li>
                </ul>
            </li>
            <li v-if="showContextElements.selection" class="py-2">
                <ul>
                    <li>
                        <button
                            type="button"
                            class="flex items-center w-full px-2 space-x-2 bg-white hover:bg-stone-100 dark:bg-neutral-950 dark:hover:bg-neutral-900"
                            @click="contextCommand(() => editor.chain().focus().toggleBold().run())"
                        >
                            <span class="relative grow-0 px-2">
                                <icon icon="fa/solid/bold" class="w-3 h-3"></icon>
                            </span>
                            <span class="flex-auto py-1.5 text-sm text-left">
                                {{ lang('common::common.wysiwyg.bold') }}
                            </span>
                        </button>
                    </li>
                    <li>
                        <button
                            type="button"
                            class="flex items-center w-full px-2 space-x-2 bg-white hover:bg-stone-100 dark:bg-neutral-950 dark:hover:bg-neutral-900"
                            @click="contextCommand(() => editor.chain().focus().toggleUnderline().run())"
                        >
                            <span class="relative grow-0 px-2">
                                <icon icon="fa/solid/underline" class="w-3 h-3"></icon>
                            </span>
                            <span class="flex-auto py-1.5 text-sm text-left">
                                {{ lang('common::common.wysiwyg.underline') }}
                            </span>
                        </button>
                    </li>
                    <li>
                        <button
                            type="button"
                            class="flex items-center w-full px-2 space-x-2 bg-white hover:bg-stone-100 dark:bg-neutral-950 dark:hover:bg-neutral-900"
                            @click="contextCommand(() => editor.chain().focus().toggleItalic().run())"
                        >
                            <span class="relative grow-0 px-2">
                                <icon icon="fa/solid/italic" class="w-3 h-3"></icon>
                            </span>
                            <span class="flex-auto py-1.5 text-sm text-left">
                                {{ lang('common::common.wysiwyg.italic') }}
                            </span>
                        </button>
                    </li>
                    <li>
                        <button
                            type="button"
                            class="flex items-center w-full px-2 space-x-2 bg-white hover:bg-stone-100 dark:bg-neutral-950 dark:hover:bg-neutral-900"
                            @click="contextCommand(() => editor.chain().focus().toggleCode().run())"
                        >
                            <span class="relative grow-0 px-2">
                                <icon icon="fa/solid/code" class="w-3 h-3"></icon>
                            </span>
                            <span class="flex-auto py-1.5 text-sm text-left">
                                {{ lang('common::common.wysiwyg.code') }}
                            </span>
                        </button>
                    </li>
                    <li>
                        <button
                            type="button"
                            class="flex items-center w-full px-2 space-x-2 bg-white hover:bg-stone-100 dark:bg-neutral-950 dark:hover:bg-neutral-900"
                            @click="contextCommand(() => editor.commands.setTextAlign('left'))"
                        >
                            <span class="relative grow-0 px-2">
                                <icon icon="fa/solid/align-left" class="w-3 h-3"></icon>
                            </span>
                            <span class="flex-auto py-1.5 text-sm text-left">
                                {{ lang('common::common.wysiwyg.align-left') }}
                            </span>
                        </button>
                    </li>
                    <li>
                        <button
                            type="button"
                            class="flex items-center w-full px-2 space-x-2 bg-white hover:bg-stone-100 dark:bg-neutral-950 dark:hover:bg-neutral-900"
                            @click="contextCommand(() => editor.commands.setTextAlign('center'))"
                        >
                            <span class="relative grow-0 px-2">
                                <icon icon="fa/solid/align-center" class="w-3 h-3"></icon>
                            </span>
                            <span class="flex-auto py-1.5 text-sm text-left">
                                {{ lang('common::common.wysiwyg.align-center') }}
                            </span>
                        </button>
                    </li>
                    <li>
                        <button
                            type="button"
                            class="flex items-center w-full px-2 space-x-2 bg-white hover:bg-stone-100 dark:bg-neutral-950 dark:hover:bg-neutral-900"
                            @click="contextCommand(() => editor.commands.setTextAlign('right'))"
                        >
                            <span class="relative grow-0 px-2">
                                <icon icon="fa/solid/align-right" class="w-3 h-3"></icon>
                            </span>
                            <span class="flex-auto py-1.5 text-sm text-left">
                                {{ lang('common::common.wysiwyg.align-right') }}
                            </span>
                        </button>
                    </li>
                </ul>
            </li>
            <li v-if="showContextElements.table" class="py-2">
                <ul>
                    <li>
                        <button
                            type="button"
                            class="flex items-center w-full px-2 space-x-2 bg-white hover:bg-stone-100 dark:bg-neutral-950 dark:hover:bg-neutral-900"
                            @click="contextCommand(() => editor.commands.addRowBefore())"
                        >
                            <span class="relative grow-0 px-2">
                                <div class="absolute right-0 flex flex-col -translate-y-1/2 top-1/2">
                                    <icon icon="fa/solid/caret-up" class="w-2 h-2"></icon>
                                    <icon icon="fa/solid/plus" class="w-2 h-2"></icon>
                                </div>
                                <icon icon="fa/solid/table-rows" class="w-3 h-3"></icon>
                            </span>
                            <span class="flex-auto py-1.5 text-sm text-left">
                                {{ lang('common::common.wysiwyg.table.addRowBefore') }}
                            </span>
                        </button>
                    </li>
                    <li>
                        <button
                            type="button"
                            class="flex items-center w-full px-2 space-x-2 bg-white hover:bg-stone-100 dark:bg-neutral-950 dark:hover:bg-neutral-900"
                            @click="contextCommand(() => editor.commands.addRowAfter())"
                        >
                            <span class="relative grow-0 px-2">
                                <div class="absolute right-0 flex flex-col -translate-y-1/2 top-1/2">
                                    <icon icon="fa/solid/caret-down" class="w-2 h-2"></icon>
                                    <icon icon="fa/solid/plus" class="w-2 h-2"></icon>
                                </div>
                                <icon icon="fa/solid/table-rows" class="w-3 h-3"></icon>
                            </span>
                            <span class="flex-auto py-1.5 text-sm text-left">
                                {{ lang('common::common.wysiwyg.table.addRowAfter') }}
                            </span>
                        </button>
                    </li>
                    <li>
                        <button
                            type="button"
                            class="flex items-center w-full px-2 space-x-2 bg-white hover:bg-stone-100 dark:bg-neutral-950 dark:hover:bg-neutral-900"
                            @click="contextCommand(() => editor.commands.deleteRow())"
                        >
                            <span class="relative grow-0 px-2">
                                <div class="absolute right-0 flex flex-col -translate-y-1/2 top-1/2">
                                    <icon icon="fa/solid/minus" class="w-2 h-2"></icon>
                                </div>
                                <icon icon="fa/solid/table-rows" class="w-3 h-3"></icon>
                            </span>
                            <span class="flex-auto py-1.5 text-sm text-left">
                                {{ lang('common::common.wysiwyg.table.deleteRow') }}
                            </span>
                        </button>
                    </li>
                </ul>
            </li>
            <li v-if="showContextElements.table" class="py-2">
                <ul>
                    <li>
                        <button
                            type="button"
                            class="flex items-center w-full px-2 space-x-2 bg-white hover:bg-stone-100 dark:bg-neutral-950 dark:hover:bg-neutral-900"
                            @click="contextCommand(() => editor.commands.addColumnBefore())"
                        >
                            <span class="relative grow-0 px-2">
                                <div class="absolute right-0 flex flex-col -translate-y-1/2 top-1/2">
                                    <icon icon="fa/solid/caret-left" class="w-2 h-2"></icon>
                                    <icon icon="fa/solid/plus" class="w-2 h-2"></icon>
                                </div>
                                <icon icon="fa/solid/table-columns" class="w-3 h-3"></icon>
                            </span>
                            <span class="flex-auto py-1.5 text-sm text-left">
                                {{ lang('common::common.wysiwyg.table.addColumnBefore') }}
                            </span>
                        </button>
                    </li>

                    <li>
                        <button
                            type="button"
                            class="flex items-center w-full px-2 space-x-2 bg-white hover:bg-stone-100 dark:bg-neutral-950 dark:hover:bg-neutral-900"
                            @click="contextCommand(() => editor.commands.addColumnAfter())"
                        >
                            <span class="relative grow-0 px-2">
                                <div class="absolute right-0 flex flex-col -translate-y-1/2 top-1/2">
                                    <icon icon="fa/solid/caret-right" class="w-2 h-2"></icon>
                                    <icon icon="fa/solid/plus" class="w-2 h-2"></icon>
                                </div>
                                <icon icon="fa/solid/table-columns" class="w-3 h-3"></icon>
                            </span>
                            <span class="flex-auto py-1.5 text-sm text-left">
                                {{ lang('common::common.wysiwyg.table.addColumnAfter') }}
                            </span>
                        </button>
                    </li>

                    <li>
                        <button
                            type="button"
                            class="flex items-center w-full px-2 space-x-2 bg-white hover:bg-stone-100 dark:bg-neutral-950 dark:hover:bg-neutral-900"
                            @click="contextCommand(() => editor.commands.deleteColumn())"
                        >
                            <span class="relative grow-0 px-2">
                                <div class="absolute right-0 flex flex-col -translate-y-1/2 top-1/2">
                                    <icon icon="fa/solid/minus" class="w-2 h-2"></icon>
                                </div>
                                <icon icon="fa/solid/table-columns" class="w-3 h-3"></icon>
                            </span>
                            <span class="flex-auto py-1.5 text-sm text-left">
                                {{ lang('common::common.wysiwyg.table.deleteColumn') }}
                            </span>
                        </button>
                    </li>
                </ul>
            </li>
            <li v-if="showContextElements.table" class="py-2">
                <ul>
                    <li>
                        <button
                            type="button"
                            class="flex items-center w-full px-2 space-x-2 bg-white hover:bg-stone-100 dark:bg-neutral-950 dark:hover:bg-neutral-900"
                            @click="contextCommand(() => editor.commands.mergeCells())"
                        >
                            <span class="relative grow-0 px-2">
                                <div class="absolute right-0 flex flex-col -translate-y-1/2 top-1/2">
                                    <icon icon="fa/solid/left-right" class="w-2 h-2"></icon>
                                </div>
                                <icon icon="fa/solid/table-cells" class="w-3 h-3"></icon>
                            </span>
                            <span class="flex-auto py-1.5 text-sm text-left">
                                {{ lang('common::common.wysiwyg.table.mergeCells') }}
                            </span>
                        </button>
                    </li>
                    <li>
                        <button
                            type="button"
                            class="flex items-center w-full px-2 space-x-2 bg-white hover:bg-stone-100 dark:bg-neutral-950 dark:hover:bg-neutral-900"
                            @click="contextCommand(() => editor.commands.splitCell())"
                        >
                            <span class="relative grow-0 px-2">
                                <div class="absolute right-0 flex flex-col -translate-y-1/2 top-1/2">
                                    <icon icon="fa/solid/split" class="w-2 h-2"></icon>
                                </div>
                                <icon icon="fa/solid/table-cells" class="w-3 h-3"></icon>
                            </span>
                            <span class="flex-auto py-1.5 text-sm text-left">
                                {{ lang('common::common.wysiwyg.table.splitCell') }}
                            </span>
                        </button>
                    </li>
                </ul>
            </li>
            <li v-if="showContextElements.table" class="py-2">
                <ul>
                    <li>
                        <button
                            type="button"
                            class="flex items-center w-full px-2 space-x-2 bg-white hover:bg-stone-100 dark:bg-neutral-950 dark:hover:bg-neutral-900"
                            @click="contextCommand(() => editor.commands.toggleHeaderCell())"
                        >
                            <span class="relative grow-0 px-2">
                                <div class="absolute right-0 flex flex-col -translate-y-1/2 top-1/2">
                                    <icon icon="fa/solid/window-maximize" class="w-2 h-2"></icon>
                                </div>
                                <icon icon="fa/solid/table-cells" class="w-3 h-3"></icon>
                            </span>
                            <span class="flex-auto py-1.5 text-sm text-left">
                                {{ lang('common::common.wysiwyg.table.toggleHeaderCell') }}
                            </span>
                        </button>
                    </li>
                    <li>
                        <button
                            type="button"
                            class="flex items-center w-full px-2 space-x-2 bg-white hover:bg-stone-100 dark:bg-neutral-950 dark:hover:bg-neutral-900"
                            @click="contextCommand(() => editor.commands.toggleHeaderRow())"
                        >
                            <span class="relative grow-0 px-2">
                                <div class="absolute right-0 flex flex-col -translate-y-1/2 top-1/2">
                                    <icon icon="fa/solid/window-maximize" class="w-2 h-2"></icon>
                                    <icon icon="fa/solid/left-right" class="w-2 h-2"></icon>
                                </div>
                                <icon icon="fa/solid/table-cells" class="w-3 h-3"></icon>
                            </span>
                            <span class="flex-auto py-1.5 text-sm text-left">
                                {{ lang('common::common.wysiwyg.table.toggleHeaderRow') }}
                            </span>
                        </button>
                    </li>
                    <li>
                        <button
                            type="button"
                            class="flex items-center w-full px-2 space-x-2 bg-white hover:bg-stone-100 dark:bg-neutral-950 dark:hover:bg-neutral-900"
                            @click="contextCommand(() => editor.commands.toggleHeaderColumn())"
                        >
                            <span class="relative grow-0 px-2">
                                <div class="absolute right-0 flex flex-col -translate-y-1/2 top-1/2">
                                    <icon icon="fa/solid/window-maximize" class="w-2 h-2"></icon>
                                    <icon icon="fa/solid/up-down" class="w-2 h-2"></icon>
                                </div>
                                <icon icon="fa/solid/table-cells" class="w-3 h-3"></icon>
                            </span>
                            <span class="flex-auto py-1.5 text-sm text-left">
                                {{ lang('common::common.wysiwyg.table.toggleHeaderColumn') }}
                            </span>
                        </button>
                    </li>
                </ul>
            </li>
            <li v-if="showContextElements.table" class="py-2">
                <ul>
                    <li>
                        <button
                            type="button"
                            class="flex items-center w-full px-2 space-x-2 bg-white hover:bg-stone-100 dark:bg-neutral-950 dark:hover:bg-neutral-900"
                            @click="contextCommand(() => editor.commands.deleteTable())"
                        >
                            <span class="relative grow-0 px-2">
                                <div class="absolute right-0 flex flex-col -translate-y-1/2 top-1/2">
                                    <icon icon="fa/solid/xmark" class="w-2 h-2"></icon>
                                </div>
                                <icon icon="fa/solid/table" class="w-3 h-3"></icon>
                            </span>
                            <span class="flex-auto py-1.5 text-sm text-left">
                                {{ lang('common::common.wysiwyg.table.deleteTable') }}
                            </span>
                        </button>
                    </li>
                </ul>
            </li>
        </ul>
    </div>
</template>

<script setup lang="ts">
import { vOnClickOutside } from '@vueuse/components';
import { ref, toRefs } from 'vue';

interface Props {
    editor: any;
    editorWrapper: any;
}

const props = defineProps<Props>();

const emit = defineEmits<{
    (event: 'insert-image'): void;
    (event: 'insert-file'): void;
}>();

const { editor, editorWrapper } = toRefs(props);

const contextMenu = ref(null);
const showingContextMenu = ref(false);

const showContextElements = ref({
    selection: false,
    table: false,
});

const showContextMenu = () => {
    let clickX = event.clientX;
    let clickY = event.clientY;

    const wrapperRect = editorWrapper.value.getBoundingClientRect();

    clickX -= wrapperRect.left;
    clickY -= wrapperRect.top;

    contextMenu.value.style.top = `${clickY}px`;
    contextMenu.value.style.left = `${clickX}px`;

    showingContextMenu.value = true;

    /**
     * Select items to show in context menu
     */
    showContextElements.value = {
        selection: false,
        table: false,
    };

    if (editor.value.isActive('table')) {
        showContextElements.value.table = true;
    }

    if (editor.value.state.selection.from !== editor.value.state.selection.to) {
        showContextElements.value.selection = true;
    }
};

const hideContextMenu = () => {
    showingContextMenu.value = false;
};

const toggleContextMenu = () => {
    showContextMenu();
};

const contextCommand = (command) => {
    command();
    hideContextMenu();
};

defineExpose({
    showContextMenu,
    hideContextMenu,
    toggleContextMenu,
    contextCommand,
});
</script>
